(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {
      super();

      this.setHeaderHeight =
        this.setHeaderHeight.bind(this);
    }

    connectedCallback() {

      this.header =
        document.querySelector(
          '.section-header'
        );

      if (!this.header) {
        return;
      }

      this.setHeaderHeight();

      this.header.classList.add(
        'shopify-section-header-sticky'
      );

      window.addEventListener(
        'resize',
        this.setHeaderHeight
      );

    }

    disconnectedCallback() {

      window.removeEventListener(
        'resize',
        this.setHeaderHeight
      );

    }

    setHeaderHeight() {

      if (!this.header) {
        return;
      }

      document.documentElement
        .style
        .setProperty(
          '--header-height',
          `${this.header.offsetHeight}px`
        );

    }

  }

  if (
    !customElements.get(
      'sticky-header'
    )
  ) {

    customElements.define(
      'sticky-header',
      StickyHeader
    );

  }

  document.addEventListener(
    'open',
    (event) => {

      if (
        !(event.target instanceof HTMLElement) ||
        !event.target.matches(
          'shopify-account'
        )
      ) {
        return;
      }

      const bottom =
        Math.max(
          0,
          Math.round(
            event.target
              .getBoundingClientRect()
              .bottom
          )
        );

      event.target.style.setProperty(
        '--account-dialog-top',
        `${bottom}px`
      );

    },
    true
  );


  } catch(e) { console.error(e); }
})();
})();
